import * as React from "react";
import { Context } from "./_context";
export const SwitcherIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.25 6v5.19l1.72-1.72 1.06 1.06-3 3a.75.75 0 0 1-.946.094l-.114-.094-3-3 1.06-1.06 1.72 1.72V6h1.5ZM4.5 2.25c.199 0 .39.08.53.22l3 3-1.06 1.06-1.72-1.72V10h-1.5V4.81L2.03 6.53.97 5.47l3-3 .114-.094A.75.75 0 0 1 4.5 2.25Z", fill: "currentColor" }));
  return iconset[size];
};
SwitcherIcon.iconId = "OcuDAi";
